// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconWheelchair = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M14 7.83a3.001 3.001 0 10-2 0V8H8v6h2v-4h2v4h4.28l1.771 5.316 1.898-.632L17.72 12H14zM14 5a1 1 0 11-2 0 1 1 0 012 0"
    />,
    <path d="M3.114 16.525a5.46 5.46 0 012.926-4.838v2.481a3.461 3.461 0 105.996 2.357V16h2v.525a5.461 5.461 0 11-10.922 0" />
  );
export default SvgIconWheelchair;
